export const ALL_CATALOG_ENTRY_COLOR = "#2339C9";
